import React from 'react';
import { Colors } from '../../constants';

const ChevronDown = () => {
  return(
    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.91584 10.1144L11.0391 2.71958H0.792572L5.91584 10.1144Z"
        fill={`#${Colors.gray}`} />
    </svg>
  );
};

export default ChevronDown;
